var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Horizontal-menu',{staticClass:"horiMenu",attrs:{"page":_vm.route}}),_c('DevicesMap',{attrs:{"devices":_vm.devicesData,"provinces":_vm.provincesData,"causes":_vm.causesData,"actions":_vm.actionsData,"states":_vm.statesData,"vaccintypes":_vm.vaccintypesData,"loader":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }